import { useEffect } from 'react';
import get from 'lodash/get';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box } from 'components';
import { Spinner } from 'components/shared';
import Typography from '@mui/material/Typography';
import AssignmentForm, {
  IAssignmentFormValues,
} from '../../../../components/employer/onboarding/AssignmentForm';
import useEmployerOnboarding from '../../../../hooks/useEmployerOnboarding';
import { useAlerts } from '../../../../hooks';
import { getRoutes } from '../../../../utils';

const OnboardingAssignmentCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const onboardingId = get(location, 'state.onboardingId', null);
  const { showToast } = useAlerts();

  const {
    onboarding: { oneById: onboardingAPI },
    assignments: { new: createAssignment },
  } = useEmployerOnboarding();

  useEffect(() => {
    if (!onboardingId) {
      navigate(getRoutes().employer.onboarding.root);
      return;
    }
    onboardingAPI.get({ variables: { onboardingId } });
  }, [onboardingId]);

  const onboarding = onboardingAPI.data?.onboarding;

  const goBackToOnboarding = () => {
    const routesWithId = getRoutes({ id: onboardingId });
    navigate(routesWithId.employer.onboarding.edit);
  };

  const handleSave = async (values: IAssignmentFormValues) => {
    try {
      await Promise.all(
        values.onboardingDocumentIds.map((onboardingDocumentId) =>
          createAssignment.create({
            variables: {
              onboardingId,
              onboardingDocumentId,
              employeeId: values.employeeId,
            },
          }),
        ),
      );
      showToast({ title: 'Assignment(s) created' });
      goBackToOnboarding();
    } catch (err) {
      showToast({
        title: 'There was an error creating the assignment',
      });
    }
  };

  if (onboardingAPI.loading || !onboarding) {
    return (
      <Box>
        <Spinner />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant={'h2'} mt={2} mb={2}>
        Assign to: {onboarding.name}
      </Typography>
      <AssignmentForm
        onboarding={onboarding}
        saving={createAssignment.loading}
        handleSave={handleSave}
        handleCancel={goBackToOnboarding}
      />
    </Box>
  );
};

export default OnboardingAssignmentCreate;
